// extracted by mini-css-extract-plugin
export default {"terms-modal-wrapper":"TermsModal_terms-modal-wrapper__J6PHN","terms-checkbox":"TermsModal_terms-checkbox__vT9yM"};